export const MerchandisingProgramVisitLengthCategoryEnumValue = {
  None: 0,

  Hours: 1,
  Days: 10,
};

export const MerchandisingProgramVisitLengthCategoryEnum = [
  {
    value: MerchandisingProgramVisitLengthCategoryEnumValue.Hours,
    labelFrench: 'Heures',
    labelEnglish: 'Hours',
  },
  {
    value: MerchandisingProgramVisitLengthCategoryEnumValue.Days,
    labelFrench: 'Jours',
    labelEnglish: 'Days',
  },
];

export default MerchandisingProgramVisitLengthCategoryEnum;
